import AdvancedFeaturesPages from "@/app/app-shared/advanced-features";
import AdminSetAdvancedFeaturesPage from "@/app/app-shared/advanced-features/AdminSetAdvancedFeaturesPage";
import AgentLocationProjectTable from "@/app/app-shared/agentLocations/table/agent-location-projects-table";
import CreateLDPWithStepper from "@/app/app-shared/project-landing-pages/CreateLDPWithStepper";
import ProjectLandingGridListing from "@/app/app-shared/project-landing-pages/grid-listing";
import CreateEditProject from "@/app/app-shared/project/create-edit";
import AgentProjectsTable from "@/app/app-shared/project/project-table/agent-projects-table";
import CreateUser from "@/app/shared/roles-permissions/create-user";
import { routes } from "@/config/routes";
import AmenityPage from "@/page/amenity/AmenityPage";
import DeveloperListingPage from "@/page/developer/DeveloperListingPage";
import DisclaimerListingPage from "@/page/disclaimer";
import EmailTemplatePage from "@/page/email-template/EmailTemplatePage";
import EnquiryEntriesPage from "@/page/enquiry-entries/EnquiryEntriesPage";
import FloorPlanUnitsPage from "@/page/floor-plan-units/FloorPlanUnitsPage";
import FloorPlanPage from "@/page/floor-plans/FloorPlansPage.tsx";
import FollowUpPage from "@/page/follow-up/FollowUp";
import Home from "@/page/Home";
import ImportTaskListingPage from "@/page/import-data/ImportTaskListingPage";
import LoginActivityPage from "@/page/login-activity";
import MortgagePage from "@/page/mortgage";
import PrivacyPolicyPage from "@/page/privacy-policy/PrivacyPolicyPage";
import ProjectCategoryListingPage from "@/page/project-category/ProjectCategoryListingPage";
import ProjectPage from "@/page/project/ProjectPage";
import PromotionBannerListingPage from "@/page/promotion-banner/PromotionBannerListingPage";
import RoundRobinPage from "@/page/round-robin";
import EditAgencySetting from "@/page/settings/EditAgencySetting";
import ProfilePage from "@/page/settings/ProfilePage";
import SiteContentCrUpPage from "@/page/site-content/SiteContentCrUpPage";
import SiteContentListingPage from "@/page/site-content/SiteContentListingPage";
import SystemSiteContentPage from "@/page/site-content/SystemSiteContentPage";
import Team from "@/page/team";
import UnitTransactionPage from "@/page/unit-transaction/UnitTransactionPage";
import UnitTypeListingPage from "@/page/unit-types/UnitTypeListingPage";
import UserPreferencePage from "@/page/user-preference/UserPreferencePage";
import EditUserPage from "@/page/user/edit-user";
import Users from "@/page/Users.tsx";
import VirtualProjectListingPage from "@/page/virtual-projects/VirutalProjectsListingPage";
import WebhookSettingPage from "@/page/webhook/WebhookSettingPage";
import WhatsappListingPage from "@/page/whatsapp/WhatsappListingPage.tsx";
import IntegrationsPage from "@/page/integrations/IntegrationsPage";
import BenefitsPage from "@/page/benefits/BenefitsPage";
import { privateRoutesType } from "@/types/routes";
import { Roles } from "@/utilities/types/Users";
import AdReportPage from "@/page/ad-report/AdReportPage";
import PackageTable from "@/app/app-shared/package/package-table";
import CreateEditPackage from "@/app/app-shared/package/create-edit";
import AdminPricingPlansWithWrapper from "@/components/pricing-plans/admin-pricing-plans";
import ApiKeyPage from "@/page/api-key";
import PromotionTable from "@/app/app-shared/promotion/promotion-table";
import CreateEditPromotion from "@/app/app-shared/promotion/create-edit";
import VoucherPage from "@/app/app-shared/voucher";
import DefaultLayout from "@/components/layout/layout";
import { Fragment } from "react/jsx-runtime";
import PaymentTable from "@/app/app-shared/package/payment-table";
import InvoiceTable from "@/app/app-shared/invoice/table";
import ConfirmPaymentPage from "@/page/confirm-payment";
import ProjectListingPage from "@/page/project-listing/ProjectListingPage";
import MyProjectsPage from "@/page/my-projects/MyProjectsPage";
import WebsiteSuspended from "@/components/website-suspended";
import AdCreditsDashboard from "@/page/ad-credits/AdCreditsDashboard";
import ReportPage from "@/page/report/ReportPage";
import AgencyIntegrationPage from "@/page/agency-integration";
import GoogleCallback from "@/page/google-callback";
import Dashboard from "@/page/Dashboard";
import CalculatorFormulaPage from "@/page/calculator-formula";
import EditSubUserSetting from "@/page/settings/EditSubUserSetting";
import GoogleAdsAccountsPage from "@/page/google-ads-accounts/GoogleAdsAccountsPage";
import CPCInsightsPage from "@/page/cpc-insights/CPCInsightsPage";
import InstallPage from "@/page/InstallPage";
import PushNotificationPage from "@/page/push-notification/PushNotificationPage";
import CreateEditPushNotificationPage from "@/page/push-notification/CreateEditPushNotificationPage";

export const privateRoutes: privateRoutesType[] = [
  {
    path: routes.home,
    exact: true,
    component: Home,
    layout: Fragment,
  },
  {
    path: routes.dashboard,
    exact: true,
    component: Dashboard,
    layout: DefaultLayout,
  },
  {
    path: routes.projectListing,
    exact: true,
    component: ProjectListingPage,
    layout: DefaultLayout,
  },
  {
    path: routes.user.create,
    component: CreateUser,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // User
  {
    path: routes.user.listing,
    component: Users,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.user.create,
    component: CreateUser,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },
  {
    path: routes.user.edit(":id"),
    component: EditUserPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  // Team
  {
    path: routes.team.listing,
    component: Team,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },

  /// Project
  {
    path: routes.project.listing,
    component: ProjectPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY, Roles.ADMIN],
  },
  {
    path: routes.myProjects,
    component: MyProjectsPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.project.create,
    component: CreateEditProject,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  {
    path: routes.project.edit(),
    component: CreateEditProject,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },
  // Contact Sale
  {
    path: routes.contacts.listing,
    component: EnquiryEntriesPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY, Roles.ADMIN, Roles.USER],
  },

  // agency
  {
    path: routes.setting.agency,
    component: EditAgencySetting,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.setting.googleAdsAccounts,
    component: GoogleAdsAccountsPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  {
    path: routes.project.agentListing,
    component: AgentProjectsTable,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },

  //Profile

  {
    path: routes.account.profile,
    component: ProfilePage,
    layout: DefaultLayout,
  },

  // Setting

  // {
  //   path: routes.setting.locaion,
  //   component: SectionConfigPage,
  //   layout: DefaultLayout,
  //   permissions: [Roles.AGENCY],
  // },
  //Location
  // {
  //   path: routes.location.listing,
  //   component: LocationListingPage,
  //   layout: DefaultLayout,
  //   permissions: [Roles.ADMIN],
  // },

  // {
  //   path: routes.agentLocation.listing,
  //   component: LayoutPage,
  //   layout: DefaultLayout,
  //   permissions: [Roles.AGENCY],
  // },

  {
    path: routes.agentLocation.projects,
    component: AgentLocationProjectTable,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.importData.listing,
    component: ImportTaskListingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // unit type
  {
    path: routes.unitType.listing,
    component: UnitTypeListingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // project category
  {
    path: routes.projectCategory.listing,
    component: ProjectCategoryListingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // developer
  {
    path: routes.developer.listing,
    component: DeveloperListingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // promotion banner
  {
    path: routes.promotionBanner.listing,
    component: PromotionBannerListingPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY, Roles.ADMIN],
  },

  // unit transaction
  {
    path: routes.unitTransaction.listing(":id"),
    component: UnitTransactionPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  // user preference
  {
    path: routes.userPreference.listing,
    component: UserPreferencePage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  // amenity
  {
    path: routes.amenity.listing(":id"),
    component: AmenityPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  //Floorplan
  {
    path: routes.floorPlan.listing(":id"),
    component: FloorPlanPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  {
    path: routes.landingPages.listing,
    component: ProjectLandingGridListing,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  {
    path: routes.landingPages.create,
    component: () => {
      return CreateLDPWithStepper({ backTo: routes.landingPages.listing });
    },
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  {
    // TODO: refactor this route to use route .create
    path: routes.landingPages.tutorialCreate,
    component: () => {
      return CreateLDPWithStepper({ backTo: "/" });
    },
    layout: Fragment,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  {
    path: routes.projectLandingPages.listing(":id"),
    component: ProjectLandingGridListing,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  {
    path: routes.unit.listing(),
    component: FloorPlanUnitsPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },

  {
    path: routes.virtual.listing(":id"),
    component: VirtualProjectListingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },
  {
    path: routes.siteContent.listing,
    component: SiteContentListingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN, Roles.AGENCY],
  },
  {
    path: routes.siteContent.create,
    component: SiteContentCrUpPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.siteContent.systemEdit(),
    component: SystemSiteContentPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  {
    path: routes.siteContent.edit(),
    component: SiteContentCrUpPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  //Whatsapp
  {
    path: routes.whatsapp.listing,
    component: WhatsappListingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  //disclaimer
  {
    path: routes.disclaimer.listing,
    component: DisclaimerListingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  //Mortgage
  {
    path: routes.mortgage.listing,
    component: MortgagePage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.calculatorFormula,
    component: CalculatorFormulaPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  //apiKey
  {
    path: routes.apiKey.listing,
    component: ApiKeyPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  // {
  //   path: routes.layout.listing,
  //   component: LayoutPage,
  //   layout: DefaultLayout,
  //   permissions: [Roles.AGENCY],
  // },
  {
    path: routes.followUp.listing,
    component: FollowUpPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY, Roles.USER],
  },

  // Integrations
  {
    path: routes.integrations,
    component: IntegrationsPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // Webhook (keeping for backward compatibility)
  {
    path: routes.webhook,
    component: WebhookSettingPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // Email template
  {
    path: routes.emailTemplate,
    component: EmailTemplatePage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // Email template
  {
    path: routes.privacyPolicy,
    component: PrivacyPolicyPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  // Advance feature
  {
    path: routes.advanceFeatures,
    component: AdvancedFeaturesPages,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.user.advanceFeature(":id"),
    component: AdminSetAdvancedFeaturesPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },

  // Login activity
  {
    path: routes.loginActivity,
    component: LoginActivityPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.user.loginActivity(":id"),
    component: LoginActivityPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.robin.listing,
    component: RoundRobinPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.adReport,
    component: AdReportPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.adCredit.dashboard,
    component: AdCreditsDashboard,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.CPCInsights,
    component: CPCInsightsPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.scheduleCampaignReview,
    component: ScheduleCampaignReviewPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.benefits,
    component: BenefitsPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.package.plans,
    component: AdminPricingPlansWithWrapper,
    layout: Fragment,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.package.listing,
    component: PackageTable,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.package.payment,
    component: PaymentTable,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.package.create,
    component: CreateEditPackage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.package.edit(),
    component: CreateEditPackage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.promotion.listing,
    component: PromotionTable,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.promotion.create,
    component: CreateEditPromotion,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.promotion.edit(),
    component: CreateEditPromotion,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.invoice.listing,
    component: InvoiceTable,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.voucher.root,
    component: VoucherPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.voucher.byPromotion(),
    component: VoucherPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.confirmPayment,
    component: ConfirmPaymentPage,
    layout: Fragment,
    permissions: [Roles.AGENCY],
  },
  // {
  //   path: routes.suspensionManagement,
  //   component: SuspensionManagementPage,
  //   layout: DefaultLayout,
  //   permissions: [Roles.ADMIN],
  // },
  {
    path: routes.websiteSuspended,
    component: WebsiteSuspended,
    layout: Fragment,
    permissions: [Roles.AGENCY, Roles.USER],
  },
  {
    path: routes.report.listing,
    component: ReportPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.agency.integrations,
    component: AgencyIntegrationPage,
    layout: DefaultLayout,
    permissions: [Roles.AGENCY],
  },
  {
    path: routes.callback.google,
    component: GoogleCallback,
    layout: Fragment,
    permissions: [Roles.AGENCY],
  },

  {
    path: routes.install,
    component: InstallPage,
    layout: Fragment,
    permissions: [Roles.AGENCY, Roles.USER],
  },
  //sub-user/user role
  {
    path: routes.setting.subUser,
    component: EditSubUserSetting,
    layout: DefaultLayout,
    permissions: [Roles.USER],
  },

  // Push Notification (Super Admin)
  {
    path: routes.pushNotification.listing,
    component: PushNotificationPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.pushNotification.create,
    component: CreateEditPushNotificationPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
  {
    path: routes.pushNotification.edit(),
    component: CreateEditPushNotificationPage,
    layout: DefaultLayout,
    permissions: [Roles.ADMIN],
  },
];
import ScheduleCampaignReviewPage from "@/page/schedule-campaign-review/ScheduleCampaignReviewPage";
